// 시장지수 API
import axiosInstance from './axiosInstance';

// 기간 내 시장지수 조회
export const fetchMarketIndex = (startDate, endDate) =>
  axiosInstance.get('/market-index', { params: { start_date: startDate, end_date: endDate } })
    .then(r => r.data);

// 과거 시장지수 일괄 수집 (timeout 넉넉하게 180초)
export const collectMarketHistory = (startDate, endDate) =>
  axiosInstance.post('/market-index/collect-history',
    { start_date: startDate, end_date: endDate },
    { timeout: 180000 },
  ).then(r => r.data);

// VKOSPI 과거 1년치 즉시 수집
export const collectVkospi = () =>
  axiosInstance.post('/market-index/collect-vkospi', {}, { timeout: 120000 })
    .then(r => r.data);

// 특정일 원달러 환율 조회 (휴장일이면 직전 영업일 값 반환)
export const fetchExchangeRate = (targetDate) =>
  axiosInstance.get('/market-index/exchange-rate', { params: { target_date: targetDate } })
    .then(r => r.data);
